import * as React from 'react';

const Si24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "red", d: "M3 14v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M5 6a2 2 0 0 0-2 2v2h18V8a2 2 0 0 0-2-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#00F", d: "M3 10h18v4H3" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#00F",
    d: "M8.813 8.014c.263.022.387.061.526.096q.276.075.545.182v.003l.116.047c-.08 1.453-.127 2.251-.313 2.62-.203.396-.398.686-1.188 1.038-.788-.352-.983-.642-1.186-1.039-.188-.368-.233-1.166-.313-2.62l.116-.046v-.003c.23-.085.41-.15.538-.182.14-.035.264-.074.528-.096q.129-.01.315-.014.185.003.316.014"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "m8.985 10.385.286-.458.446.732c-.007.012-.383.674-1.073 1.044l-.144.072-.144-.072c-.69-.37-1.066-1.032-1.073-1.044l.447-.732.285.458L8.5 9.5z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "red",
    d: "M8.813 8.014c.263.022.387.061.526.096q.276.075.545.182v.003l.116.047-.057.97c-.055.855-.117 1.373-.256 1.65l-.077.143c-.184.326-.42.587-1.111.895l-.27-.129c-.568-.296-.739-.563-.916-.91-.14-.276-.202-.794-.257-1.648L7 8.342l.116-.047v-.003c.23-.085.41-.15.538-.182.14-.035.264-.074.528-.096q.129-.01.315-.014.185.003.316.014m-.607.3c-.235.019-.336.051-.477.087l-.005.001a4 4 0 0 0-.412.138c.034.625.063 1.111.102 1.487.045.428.1.668.166.797l.07.133c.07.124.142.226.245.324.122.118.304.242.604.386.301-.144.483-.268.606-.386.137-.13.218-.268.315-.457.065-.13.12-.37.165-.797.04-.376.068-.863.102-1.488q-.084-.033-.168-.061L9.26 8.4c-.14-.035-.24-.068-.473-.087a5 5 0 0 0-.29-.013 5 5 0 0 0-.292.013Z"
  }
));
Si24.Size = 24;
Si24.Title = "Si";

export { Si24 as default };
